import React from 'react'
import {Link} from 'react-router-dom'
import './style.css'
import LocationMap from '../LocationModal/LocationModal'
import AnchorLink from 'react-anchor-link-smooth-scroll'

const Welcome = () =>{
    return(
        <div className="welcome-area">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="welcome-content">
                            <h2>Welcome to our big day!</h2>
                            <p>It’s a dream come true to celebrate the most magical moment of our lives with you. As we exchange vows and seal them with rings forever, we couldn’t wish for anything more than having you—our most cherished and loved—by our side to bless us.</p>
                            <div className="btn"><AnchorLink href="#rsvp">RSVP</AnchorLink></div>
                            <LocationMap buttonClass={'location-btn'} />
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default Welcome;